import { Heading } from "@ariakit/react";
import classNames from "classnames";

import type { Ad as AdType } from "../../../types/ads/adResource";
import type { ListView } from "../../../types/webTypes";
import type { FeedItems } from "../../../types/content/feedItem";

import { CategoryArticlesList } from "./CategoryArticlesList/CategoryArticlesList";
import { TopicArticlesList } from "./TopicArticlesList/TopicArticlesList";
import styles from "../Feed.module.scss";
import { SponsoredBanner } from "../../Ad/SponsoredBanner/SponsoredBanner";
import { isInjectable } from "../../../utils/typechecks";

const ListLayout = ({
  data,
  listView,
  isFirstFeed,
  sponsoredBannerAdResource,
  endOfFeed,
  headerTitle,
}: {
  data: FeedItems;
  listView: ListView;
  isFirstFeed?: boolean;
  sponsoredBannerAdResource?: AdType;
  endOfFeed?: boolean;
  headerTitle?: string;
}) => {
  if (data.length === 0) {
    return null;
  }

  return (
    <div className={listView === "category" ? styles.feed : ""}>
      {isFirstFeed && (
        <>
          <div
            className={classNames([
              styles.listHeader,
              listView === "topic" && styles.listHeaderSmall,
            ])}
          >
            <Heading className={styles.listTitle}>{headerTitle}</Heading>
          </div>
          {sponsoredBannerAdResource?.havePlacementRule && (
            <SponsoredBanner resource={sponsoredBannerAdResource} />
          )}
        </>
      )}
      {data.map((feedItem, clusterIndex) => {
        if (!feedItem || isInjectable(feedItem)) return null;

        if (listView === "topic") {
          const isFirstElement = clusterIndex === 0;
          const shouldPrioritizeImageLoad = clusterIndex > 3;
          return (
            <TopicArticlesList
              feedItem={feedItem}
              shouldPrioritizeImageLoad={shouldPrioritizeImageLoad}
              isFirstElement={isFirstElement}
              key={`${feedItem.id}${clusterIndex}`}
              endOfFeed={endOfFeed && clusterIndex === data.length - 1}
              positionInFeed={clusterIndex + 1}
            />
          );
        }

        if (listView === "category") {
          return (
            <CategoryArticlesList
              feedItem={feedItem}
              positionInFeed={clusterIndex + 1}
              key={`${feedItem.id}${clusterIndex}`}
            />
          );
        }

        return null;
      })}
    </div>
  );
};

export { ListLayout };
